import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProductRefundDocument.Replace.IRequest;
type Response = Api.Core.ProductRefundDocument.Replace.IResponse;
type Headers = Api.Core.ProductRefundDocument.Replace.IHeaders;
const url = '/api/ProductManagement/ProductRefundDocument/:productId/ReplaceFile/:documentId';
export default async function productRefundDocumentReplaceApi(body: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Pick<Request, 'formFile'>, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url, { productId: body.productId, documentId: body.documentId }),
    body: { formFile: body.formFile },
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
